<!-- User Info/Edit Modal -->
<div
  style="overflow-y: auto"
  mdbModal
  id="userInfoModal"
  #userInfoModal="mdbModal"
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myBasicModalLabel"
  aria-hidden="true"
  (close)="onClosed($event)"
  [config]="{ ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="showHideModal(false)">
          <span aria-hidden="true">×</span>
        </button>
        <div>
          <h4 class="modal-title w-100" id="myModalLabel">{{ userProfile.fullName }} - User Information</h4>
          <mdb-badge class="badge-primary" *ngIf="userProfile.onboardingComplete === false">Onboarding</mdb-badge>
        </div>
      </div>
      <div class="modal-body">
        <ul class="nav nav-tabs mb-3" role="tablist">
          <li class="nav-item">
            <a [ngClass]="currentTab === 'profile' ? 'nav-link active' : 'nav-link'" aria-current="page" (click)="switchTabs('profile')"
              >Profile</a
            >
          </li>
          <li class="nav-item">
            <a [ngClass]="currentTab === 'sda-reserves' ? 'nav-link active' : 'nav-link'" (click)="switchTabs('sda-reserves')">SDA</a>
          </li>
          <li class="nav-item">
            <a [ngClass]="currentTab === 'fia-reserves' ? 'nav-link active' : 'nav-link'" (click)="switchTabs('fia-reserves')">FIA</a>
          </li>
          <li class="nav-item">
            <a [ngClass]="currentTab === 'ncino' ? 'nav-link active' : 'nav-link'" (click)="switchTabs('ncino')">nCino</a>
          </li>
          <li class="nav-item">
            <a [ngClass]="currentTab === 'documents' ? 'nav-link active' : 'nav-link'" (click)="switchTabs('documents')">Documents</a>
          </li>
        </ul>

        <div *ngIf="currentTab === 'sda-reserves'">
          <div class="d-block col-12 mb-3 text-center">
            <p class="font-weight-bold mb-1">SDA Reserved/Used</p>
          </div>
          <app-sda-reserved [selectedUserProfile]="selectedUserDetails.profile"></app-sda-reserved>
        </div>

        <div *ngIf="currentTab === 'fia-reserves'">
          <div class="d-block col-12 mb-3 text-center">
            <p class="font-weight-bold mb-1">FIA Reserved/Used</p>
          </div>
          <app-fia-reserved [selectedUserProfile]="selectedUserDetails.profile"></app-fia-reserved>
        </div>

        <div *ngIf="currentTab === 'ncino'">
          <div class="d-block col-12 mb-3 text-center">
            <p class="font-weight-bold mb-1">nCino KYC Information</p>
          </div>
          <app-user-kyc-profile [userIdentifiers]="userIdentifiers"></app-user-kyc-profile>
        </div>

        <div *ngIf="currentTab === 'documents'">
          <div class="d-block col-12 mb-3 text-center">
            <p class="font-weight-bold mb-1">Documents</p>
          </div>
          <app-document
            [userIdentifiers]="userIdentifiers"
            [spouseFullName]="selectedUserDetails.spouse?.fullName"
            [fullName]="selectedUserDetails.profile.fullName"
          ></app-document>
        </div>

        <div *ngIf="currentTab === 'profile'">
          <form #f="ngForm" (ngSubmit)="saveClicked(f)" name="user-profile-form">
            <!-- <div class="modal-body"> -->
            <div *ngIf="!busy">
              <div class="col">
                <div *ngIf="showError" class="alert alert-danger text-center font-weight-bold" role="alert">
                  {{ errorMsg }}
                </div>
                <div *ngIf="showResendRegistrationEmailMessage" class="alert alert-success text-center font-weight-bold" role="alert">
                  {{ resultResendRegistrationEmail }}
                </div>
              </div>
              <div class="d-block col-12 mb-3 text-center">
                <p class="font-weight-bold mb-1">Personal Information</p>
              </div>
              <!-- Full name -->
              <div class="md-form col-12" style="margin-top: 5px">
                <input
                  [(ngModel)]="userProfile.fullName"
                  mdbInput
                  mdbValidate
                  name="fullName"
                  type="text"
                  id="userProfileFullName"
                  class="form-control"
                  #fullName="ngModel"
                  required
                />
                <label for="userProfileFullName">Full name</label>
                <mdb-error *ngIf="fullName.invalid && (fullName.dirty || fullName.touched)">First name is required </mdb-error>
                <mdb-success *ngIf="fullName.valid && (fullName.dirty || fullName.touched)"></mdb-success>
              </div>

              <!-- Display name -->
              <div class="md-form col-12" style="margin-top: 5px">
                <input
                  [(ngModel)]="userProfile.displayName"
                  mdbInput
                  mdbValidate
                  name="displayName"
                  type="text"
                  id="userProfileDisplayName"
                  class="form-control"
                  #displayName="ngModel"
                  required
                />
                <label for="userProfileDisplayName">Display name</label>
                <mdb-error *ngIf="displayName.invalid && (displayName.dirty || displayName.touched)">Last name is required </mdb-error>
                <mdb-success *ngIf="displayName.valid && (displayName.dirty || displayName.touched)"></mdb-success>
              </div>

              <!-- E-mail -->
              <div class="md-form col-12" style="margin-top: 5px">
                <input
                  [(ngModel)]="user.email"
                  mdbInput
                  mdbValidate
                  name="email"
                  type="text"
                  id="userProfileEmail"
                  autocomplete="email"
                  class="form-control"
                  #email="ngModel"
                  required
                  [pattern]="regexForEmail"
                />
                <label for="userProfileEmail">E-mail</label>
                <mdb-error *ngIf="email.invalid && (email.dirty || email.touched)">Email address not valid</mdb-error>
                <mdb-success *ngIf="email.valid && (email.dirty || email.touched)"></mdb-success>
              </div>

              <!--Physical Address-->
              <!--
              <div class="md-form col-12" style="margin-top: 5px">
                <input
                  [(ngModel)]="userProfile.physicalAddress"
                  mdbInput
                  mdbValidate
                  name="physicalAddress"
                  type="text"
                  id="physicalAddress"
                  class="form-control"
                  #physicalAddress="ngModel"
                  maxlength="500"
                />
                <label for="physicalAddress">Physical Address</label>
              </div>
              -->

              <!--Tags-->
              <div class="md-form col-12" style="margin-top: 5px">
                <app-tags-editor [UserId]="userProfile.userId" (TagEditError)="parseAndDisplayError($event)"></app-tags-editor>
              </div>

              <div class="md-form col-12" style="margin-top: 5px; text-align: right; align-content: right">
                <small *ngIf="lastRegistrationNotificationSent.id > 0">
                  Last Sent:
                  {{ lastRegistrationNotificationSent.createdDate | date: "dd MMM yyyy HH:mm" }}
                </small>
                <mdb-badge *ngIf="lastRegistrationNotificationSent.status == 'New'" color="grey">Sending</mdb-badge>
                <mdb-badge *ngIf="lastRegistrationNotificationSent.status == 'Pending'" color="orange">Pending</mdb-badge>
                <mdb-badge *ngIf="lastRegistrationNotificationSent.status == 'Complete'" color="green">Completed</mdb-badge>
                <mdb-badge *ngIf="lastRegistrationNotificationSent.status == 'Failed'" color="red">Failed</mdb-badge>
                <mdb-badge
                  [mdbTooltip]="lastRegistrationNotificationSent.statusMessage"
                  *ngIf="
                    lastRegistrationNotificationSent.id > 0 &&
                    lastRegistrationNotificationSent.status != 'New' &&
                    lastRegistrationNotificationSent.status != 'Pending' &&
                    lastRegistrationNotificationSent.status != 'Complete' &&
                    lastRegistrationNotificationSent.status != 'Failed'
                  "
                  color="black"
                >
                  {{ lastRegistrationNotificationSent.status }}
                </mdb-badge>
                <button type="button" mdbBtn color="trakly-action" class="relative waves-light" (click)="resendRegistrationEmail()">
                  {{ lastRegistrationNotificationSent.id > 0 ? "Re-send" : "Send" }}
                  Registration Email
                </button>
              </div>
              <!-- Cellphone -->
              <div class="md-form col-12" style="margin-top: 5px">
                <input
                  [(ngModel)]="user.mobile"
                  mdbInput
                  mdbValidate
                  name="mobile"
                  type="text"
                  id="userProfileMobile"
                  class="form-control"
                  #mobile="ngModel"
                  required
                  pattern="^0?\+?\d{1,3} ?\d{2} ?\d{3} ?\d{4}$"
                  placeholder="+27 xxxxxxxxx"
                />
                <label for="userProfileMobile">Cellphone</label>
                <mdb-error *ngIf="mobile.invalid && (mobile.dirty || mobile.touched)">Cellphone number not valid</mdb-error>
                <mdb-success *ngIf="mobile.valid && (mobile.dirty || mobile.touched)"></mdb-success>
              </div>

              <!-- ID NUmber -->
              <div class="md-form col-12" style="margin-top: 5px">
                <input
                  [(ngModel)]="userProfile.idNumber"
                  mdbInput
                  mdbValidate
                  name="idNumber"
                  type="text"
                  id="userProfileIdNumber"
                  class="form-control"
                  #idNumber="ngModel"
                  placeholder="South african ID number"
                  (blur)="CheckIfIdInUse()"
                  [class.ng-invalid]="idNumberInUse"
                  [required]="userProfile.onboardingComplete"
                />
                <label for="userProfileIdNumber">ID Number</label>
                <mdb-error *ngIf="idNumber.invalid && (idNumber.dirty || idNumber.touched)">ID number not valid</mdb-error>
                <mdb-error *ngIf="idNumberInUse">Id Number already in use</mdb-error>
                <mdb-success *ngIf="idNumber.valid && (idNumber.dirty || idNumber.touched)"></mdb-success>
              </div>

              <!-- Spouse -->
              <div class="d-block col-12 mb-3 text-center">
                <p class="font-weight-bold mb-1">Spouse</p>
              </div>
              <div class="md-form col-12" style="margin-top: 5px">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title" *ngIf="!spouse">No spouse linked</h5>
                    <div class="row col-12" *ngIf="!spouse || editSpouse">
                      <div class="col-10">
                        <input
                          mdbInput
                          name="spouseSearch"
                          type="text"
                          id="spouseSearch"
                          class="form-control"
                          [(ngModel)]="spouseSearchRequest.searchTerm"
                          (keyup.enter)="SearchSpouse()"
                          placeholder="Search"
                        />
                      </div>
                      <div class="col-2">
                        <button mdbBtn type="button" size="sm" class="my-0 p btn-trakly-action" (click)="SearchSpouse()">Search</button>
                      </div>
                    </div>
                    <div class="row col-12 mx-0 px-0" *ngIf="spouse || editSpouse">
                      <table class="table table-sm" *ngIf="spouse || spouseSearchResults.length > 0">
                        <thead class="bg-light">
                          <tr>
                            <th>User Id</th>
                            <th>Full Name</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody *ngIf="spouse && !editSpouse">
                          <tr>
                            <td>
                              {{ spouse.id }}
                            </td>
                            <td>
                              <div class="d-flex align-items-center">
                                <div class="ms-3">
                                  <p class="fw-bold mb-1">{{ spouse.fullName }}</p>
                                </div>
                              </div>
                            </td>
                            <td class="text-right">
                              <button mdbBtn size="sm" class="my-0 p btn-trakly" (click)="RemoveSpouse()">Remove</button>
                              <button mdbBtn size="sm" class="my-0 p btn-trakly-action" (click)="EditSpouse()">Edit</button>
                            </td>
                          </tr>
                        </tbody>
                        <tbody *ngIf="editSpouse">
                          <tr *ngFor="let sp of spouseSearchResults">
                            <td>
                              {{ sp.id }}
                            </td>
                            <td>
                              <div class="d-flex align-items-center">
                                <div class="ms-3">
                                  <p class="fw-bold mb-1">{{ sp.fullName }}</p>
                                </div>
                              </div>
                            </td>
                            <td class="text-right">
                              <button mdbBtn size="sm" class="my-0 p btn-trakly-action" (click)="AssignSpouse(sp)">Select</button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="col" *ngIf="spouseSearchResults.length == 0 && editSpouse">
                        <div class="alert alert-warning text-center font-weight-bold" role="alert">No Users Found</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="md-form col-12" *ngIf="spouse"></div>

              <div class="form-row">
                <div class="md-form col-6">
                  <input
                    [(ngModel)]="userTradingBankAccount.accountNumber"
                    mdbInput
                    name="bankAccountNumber"
                    type="number"
                    id="userProfileBankAccountNumber"
                    class="form-control"
                    #bankAccountNumber="ngModel"
                  />
                  <label for="userProfileBankAccountNumber">Capitec Business Bank Account Number</label>
                </div>
                <div class="md-form col-6">
                  <input
                    mdbInput
                    class="form-control"
                    [(ngModel)]="userTradingBankAccount.cifNumber"
                    name="cifnumber"
                    type="text"
                    id="cifnumber"
                  />
                  <label for="cifnumber">CIF Number</label>
                </div>
              </div>

              <div class="form-row">
                <div class="md-form col-6">
                  <input
                    [(ngModel)]="userProfile.krakenReference"
                    mdbInput
                    name="cryptoReference"
                    type="text"
                    id="cryptoReference"
                    class="form-control"
                    #cryptoReference="ngModel"
                  />
                  <label for="cryptoReference">Crypto Reference ID</label>
                </div>
              </div>

              <div class="form-row">
                <div class="md-form col-6">
                  <input
                    [(ngModel)]="userProfile.sofDescription"
                    mdbInput
                    name="sofDescription"
                    type="text"
                    id="sofDescription"
                    class="form-control"
                    #sofDescription="ngModel"
                    maxlength="250"
                  />
                  <label for="sofDescription">SOF Description</label>
                </div>
              </div>

              <!-- Trading Paused flag -->
              <div class="md-form col-12 mb-4" style="margin-top: 5px">
                <select
                  class="md-form form-control browser-default w-100 mt-1"
                  id="paused"
                  [(ngModel)]="userProfile.tradingPaused"
                  name="paused"
                  placeholder="Trading Paused"
                >
                  <option *ngFor="let paused of YesNoDropdown" [ngValue]="paused.Value">
                    {{ paused.Name }}
                  </option>
                </select>
                <label for="paused" class="active">Trading Paused</label>
              </div>
              <div class="md-form col-12 mb-4" style="margin-top: 5px" *ngIf="userProfile.tradingPaused">
                <textarea
                  type="text"
                  id="form7"
                  class="md-textarea md-textarea-auto form-control"
                  mdbInput
                  mdbValidate
                  [(ngModel)]="userProfile.tradingPausedReason"
                  name="tradingPausedReason"
                  #tradingPausedReason="ngModel"
                  [required]="userProfile.tradingPaused"
                ></textarea>
                <label for="form7">Trading Paused reason</label>
                <div
                  class="text-danger small mt-1"
                  *ngIf="tradingPausedReason.invalid && (tradingPausedReason.dirty || tradingPausedReason.touched)"
                >
                  A reason is required when trading is paused
                </div>
              </div>

              <!-- Preferred Min Arb Rate -->
              <!--
              <div class="md-form col-12 mb-4" style="margin-top: 5px">
                <input
                [(ngModel)]="userProfile.preferredMinArbRate"
                mdbInput
                mdbValidate
                name="preferredMinArbRate"
                type="number"
                id="preferredMinArbRate"
                class="form-control"
                value="0.00"
                step="0.1"
                #preferredMinArbRate="ngModel"
                />
                <label for="preferredMinArbRate">Preferred Min Arb Rate</label>
                <mdb-success *ngIf="preferredMinArbRate.valid && (preferredMinArbRate.dirty || preferredMinArbRate.touched)"> </mdb-success>
              </div>
              -->

              <!-- Max Trade Amount -->
              <div class="md-form col-12 mb-4" style="margin-top: 5px">
                <input
                  [(ngModel)]="userProfile.maxTradeAmount"
                  mdbInput
                  mdbValidate
                  name="maxTradeAmount"
                  type="number"
                  id="maxTradeAmount"
                  class="form-control"
                  value="499500"
                  #maxTradeAmount="ngModel"
                />
                <label for="maxTradeAmount">Max Trade Amount</label>
                <mdb-success *ngIf="maxTradeAmount.valid && (maxTradeAmount.dirty || maxTradeAmount.touched)"> </mdb-success>
              </div>

              <!-- Pips -->
              <div class="form-check">
                <mdb-checkbox [(ngModel)]="userProfile.isDefaultPipsOverridenForUser" class="mt-2" name="pipsOverride">
                  Override Default Pips (Currently {{ systemDefaultPips }})
                </mdb-checkbox>
              </div>
              <div class="md-form col-12 mb-4" *ngIf="userProfile.isDefaultPipsOverridenForUser">
                <input
                  [(ngModel)]="userProfile.pips"
                  mdbInput
                  mdbValidate
                  name="pips"
                  type="number"
                  id="pips"
                  class="form-control"
                  #pips="ngModel"
                />
                <label for="pips">Custom Forex Pips</label>
                <mdb-error *ngIf="pips.invalid && (pips.dirty || pips.touched)">Pips</mdb-error>
                <mdb-success *ngIf="pips.valid && (pips.dirty || pips.touched)"></mdb-success>
              </div>

              <!-- Billing -->
              <div class="md-form col-6" style="margin-top: 20px">
                <select
                  class="md-form form-control browser-default w-100"
                  id="Plan"
                  [(ngModel)]="userBilling.billingTypeId"
                  name="plan"
                  placeholder="Plan"
                >
                  <option *ngFor="let billing of usersBillingDropdown" [ngValue]="billing.Id">
                    {{ billing.Name }}
                  </option>
                </select>
                <label for="Plan" class="active">Plan</label>
              </div>

              <div class="d-block col-12 mb-3 text-center">
                <p class="font-weight-bold mb-1">Sars Details</p>
              </div>

              <!-- Income Tax ref number -->
              <div class="md-form col-12" style="margin-top: 5px">
                <input
                  [(ngModel)]="userProfile.incomeTaxReferenceNumber"
                  mdbInput
                  mdbValidate
                  name="incomeTaxReferenceNumber"
                  type="text"
                  id="userProfileIncomeTaxReferenceNumber"
                  class="form-control"
                  #incomeTaxReferenceNumber="ngModel"
                  [required]="userProfile.onboardingComplete"
                />
                <label for="userProfileIncomeTaxReferenceNumber">Income Tax Reference Number</label>
                <mdb-error *ngIf="incomeTaxReferenceNumber.invalid && (incomeTaxReferenceNumber.dirty || incomeTaxReferenceNumber.touched)">
                  Income Tax Reference number not valid</mdb-error
                >
                <mdb-success *ngIf="incomeTaxReferenceNumber.valid && (incomeTaxReferenceNumber.dirty || incomeTaxReferenceNumber.touched)">
                </mdb-success>
              </div>

              <!-- Sars Username -->
              <div class="md-form col-12" style="margin-top: 5px">
                <input
                  [(ngModel)]="userProfile.sarsUsername"
                  mdbInput
                  mdbValidate
                  name="sarsUsername"
                  type="text"
                  id="userProfileSarsUsername"
                  class="form-control"
                  #sarsUsername="ngModel"
                />
                <label for="userProfileSarsUsername">Sars Login Username</label>
                <mdb-error *ngIf="sarsUsername.invalid && (sarsUsername.dirty || sarsUsername.touched)"
                  >Sars Login Username not valid</mdb-error
                >
                <mdb-success *ngIf="sarsUsername.valid && (sarsUsername.dirty || sarsUsername.touched)"></mdb-success>
              </div>

              <!-- Sars Password -->
              <div class="md-form col-12" style="margin-top: 5px">
                <input
                  [(ngModel)]="userProfile.sarsPassword"
                  mdbInput
                  mdbValidate
                  name="sarsPassword"
                  type="text"
                  id="userProfileSarsPassword"
                  class="form-control"
                  #sarsPassword="ngModel"
                />
                <label for="userProfileSarsPassword">Sars Login Password</label>
                <mdb-error *ngIf="sarsPassword.invalid && (sarsPassword.dirty || sarsPassword.touched)"
                  >Sars Login Password not valid</mdb-error
                >
                <mdb-success *ngIf="sarsPassword.valid && (sarsPassword.dirty || sarsPassword.touched)"></mdb-success>
              </div>

              <!-- notes -->
              <div class="md-form col-12" style="margin-top: 5px">
                <textarea
                  type="text"
                  id="form8"
                  class="md-textarea md-textarea-auto form-control"
                  mdbInput
                  [(ngModel)]="userProfile.onboardingReason"
                  name="form8"
                ></textarea>
                <label for="form8">Notes</label>
              </div>
            </div>
            <div class="col-12 text-center">
              <div *ngIf="busy" class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div class="modal-footer d-sm-flex" style="justify-content: space-between">
              <div></div>
              <div>
                <button *ngIf="!busy" type="submit" mdbBtn color="trakly-action" class="relative waves-light">Save</button>
                <button *ngIf="!busy" type="button" mdbBtn color="trakly" class="relative waves-light" (click)="showHideModal(false)">
                  Close
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
